<template>
  <v-card
    flat
    v-if="
      $store.getters.retrieveCurrentTrolly.order_discount.discount_enabled ==
      '1'
    "
  >
    <v-card-text class="pb-0">
      <strong> Order Discounts </strong>
    </v-card-text>

    <v-card-text
      v-if="
        this.$store.getters.retrieveCurrentTrolly.order_discount
          .discount_valid == false &&
        this.$store.getters.retrieveCurrentTrolly.order_discount.discount_id
      "
    >
      <v-alert type="error" class="ma-0" outlined text>
        Discount code
        <strong>
          {{
            this.$store.getters.retrieveCurrentTrolly.order_discount.discount_id
          }}
        </strong>
        is no longer valid
      </v-alert>
    </v-card-text>

    <v-card-text
      class="pt-0"
      v-else-if="
        this.$store.getters.retrieveCurrentTrolly.order_discount
          .discount_valid == false
      "
    >
      No discount applied
    </v-card-text>
    <v-card-text
      v-else-if="
        this.$store.getters.retrieveCurrentTrolly.order_discount.discount_row
          .discount_type == 1
      "
      class="pt-0"
    >
      You have applied discount of amount:
      <strong>
        £{{
          parseFloat(
            this.$store.getters.retrieveCurrentTrolly.order_discount
              .discount_row.discount_amount
          ).toFixed(2)
        }}
      </strong>
    </v-card-text>
    <v-card-text v-else class="pt-0">
      You have applied discount code:
      <strong>{{
        this.$store.getters.retrieveCurrentTrolly.order_discount.discount_row
          .code
      }}</strong>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-dialog
        v-if="
          discountID == null &&
          $store.getters.retrieveAdmin.account_type == 'A1'
        "
        v-model="discountAmountDialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on }">
          <v-btn outlined color="blue darken-2" v-on="on">
            <span>Enter Discount Amount</span>
            <v-icon right>mdi-currency-gbp</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title>
            <h4>Enter Discount Amonut</h4>
            <v-spacer></v-spacer>
            <v-btn icon color text @click="discountAmountDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-form
              v-model="valid"
              ref="OrderDiscountAmountForm"
              @submit.prevent="submitDiscountAmount"
            >
              <v-card flat>
                <v-card-text class="pa-0">
                  <v-text-field
                    class="mt-2"
                    @focus="$event.target.select()"
                    label="Discount Amount"
                    prefix="£"
                    v-model="discount_amount"
                    min="0"
                    step=".01"
                    type="number"
                    :rules="rules_amount"
                    hint="Amount in £ to remove from the order total"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    type="submit"
                    color="blue darken-2"
                    outlined
                    :disabled="!valid"
                    :loading="loading"
                  >
                    Apply
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-spacer />

      <v-dialog v-model="discountCodeDialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn
            outlined
            color="blue darken-2"
            v-on="on"
            v-if="
              $store.getters.retrieveCurrentTrolly.order_discount.discount_id ==
              null
            "
          >
            <span>Add Discount Code</span>
            <v-icon right>mdi-tag</v-icon>
          </v-btn>
          <v-btn
            outlined
            color="error"
            v-else
            @click="removeDiscount()"
            :loading="loading"
          >
            <span>Remove Discount</span>
            <v-icon right>mdi-tag</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title>
            <h4>Add Discount Code</h4>
            <v-spacer></v-spacer>
            <v-btn icon color text @click="discountCodeDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-form
              v-model="valid"
              ref="OrderDiscountCodeForm"
              @submit.prevent="submitDiscountCode"
            >
              <v-card flat>
                <v-card-text class="pa-0">
                  <v-text-field
                    v-model="discountCode"
                    :rules="[required('Discount Code')]"
                    label="Discount Code"
                    @focus="$event.target.select()"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    type="submit"
                    color="blue darken-2"
                    outlined
                    :disabled="!valid"
                    :loading="loading"
                  >
                    Apply
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OrderDiscounts",

  data: () => {
    return {
      valid: false,

      discountCodeDialog: false,
      discountAmountDialog: false,

      loading: false,
      discountCode: null,
      discount_amount: null,

      rules_amount: [
        (v) => /^\d*(\.\d{1,2})?$/.test(v) || "Invalid Amount Entered",
        (v) => (v < 10000 && v != null) || `Maximum value £9,999`,
      ],

      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
    };
  },

  computed: {
    discountID() {
      let value = null;

      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          this.$store.getters.retrieveCurrentTrolly.order_discount.discount_id
        ) {
          value =
            this.$store.getters.retrieveCurrentTrolly.order_discount
              .discount_id;
        }
      }

      return value;
    },
  },

  methods: {
    ...mapActions(["applyTrollyDiscountCode", "applyTrollyDiscountAmount"]),

    async removeDiscount() {
      console.log("Remove Code");
      this.loading = true;
      let result = await this.applyTrollyDiscountCode(null);

      this.loading = false;

      if (result) {
        this.discountCodeDialog = false;
        this.discountAmountDialog = false;
      }
    },

    async submitDiscountCode() {
      console.log("SUBMIT");
      this.loading = true;
      let result = await this.applyTrollyDiscountCode(this.discountCode);

      this.loading = false;

      if (result) {
        this.discountCodeDialog = false;
      }
    },

    async submitDiscountAmount() {
      console.log("SUBMIT");
      this.loading = true;
      let result = await this.applyTrollyDiscountAmount(this.discount_amount);

      this.loading = false;

      if (result) {
        this.discountAmountDialog = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>